<template>
  <div class="statistic-client--container no-select">
    <div class="alert-sm alert-success">Средний чек считается на основе выполненных записей</div>
    <div class="mrg-t-20">
      <div class="shadow-card text-center">
        <div>Дата первой записи:</div>
        <div class="mrg-t-5"><b>{{datePhpToRus(data.date_first_enroll)}}</b></div>
      </div>
      <div class="shadow-card text-center mrg-t-10">
        <div>Дата последней записи:</div>
        <div class="mrg-t-5"><b>{{datePhpToRus(data.date_last_enroll)}}</b></div>
      </div>
      <div class="shadow-card text-center mrg-t-10">
        <div>Кол-во выполненных записей:</div>
        <div class="mrg-t-5"><b>{{data.done_enrolls_count}}</b></div>
      </div>
      <div class="shadow-card text-center mrg-t-10">
        <div>Кол-во отмененных записей:</div>
        <div class="mrg-t-5"><b>{{data.canceled_enrolls_count}}</b></div>
      </div>
      <div class="shadow-card text-center mrg-t-10">
        <div>Средний чек:</div>
        <div class="mrg-t-5"><b>{{data.avg_done_price}}</b></div>
      </div>
      <div class="shadow-card text-center mrg-t-10">
        <div>Всего оказано услуг на сумму:</div>
        <div class="mrg-t-5"><b>{{data.all_checks}}</b></div>
      </div>
    </div>
  </div>
</template>

<script>
import Formatter from "@/components/libraries/Formatter";
import clientsRepository from "../../../repositories/clients";

const formatter = new Formatter();

export default {
  name: "StatisticClient",
  components: {},
  data() {
    return {
      data: {}
    };
  },
  props: {
    id: Number // ID клиента для загрузки данных
  },
  watch: {
    id: function() {
      this.loadData();
    }
  },
  computed: {},
  methods: {
    datePhpToRus(date){
      if(date !== null && date !== undefined){
        return formatter.phpDateToString(date);
      }else{
        return "нет записей";
      }
    },
    loadData() {
      if (this.id !== null) {
        this.$store.dispatch("startPreloader");
        clientsRepository.getStatistic({id: this.id}).then(resp => {
          this.data = resp.data;
          this.$store.dispatch("stopPreloader");
        }).catch(err => {
          this.$store.dispatch("addNotification", {
            text: err.response.data.message,
            time: 6,
            color: "danger"
          });
          this.$store.dispatch("stopPreloader");
        });
      }
    }
  },
  created() {
    this.loadData();
  }
};
</script>

<style scoped lang="less"></style>
